import script from "./ListProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListProducts.vue?vue&type=script&lang=ts&setup=true"

import "./ListProducts.vue?vue&type=style&index=0&id=2a531859&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a531859"]])

export default __exports__